import React from 'react'
import Form from './Components/Form'

export const App = () => {

  return (
    <>
    
      <Form />
    

    </>

  )
}
